import { TransactionStatusEnum } from '@blockcatio/tabby-library/lib/constants';

import {
  REWARD_REDEEM_STARTED,
  REWARD_REDEEM_SUBMITTED,
  REWARD_REDEEM_CONFIRMED,
  REWARD_REDEEM_REJECTED,
} from '../actionTypes';

const getInitialState = () => ({
  rewardKey: '',
  transactionHash: '',
  redemptionStatus: TransactionStatusEnum.pending,
});

const reducer = (state = getInitialState(), action) => {
  switch (action.type) {
    case REWARD_REDEEM_STARTED:
      return {
        ...state,
        rewardKey: action.rewardKey,
        transactionHash: '',
        redemptionStatus: TransactionStatusEnum.pending,
      };

    case REWARD_REDEEM_SUBMITTED:
      return {
        ...state,
        transactionHash: action.transactionHash,
      };

    case REWARD_REDEEM_CONFIRMED:
      return {
        ...state,
        redemptionStatus: TransactionStatusEnum.succeeded,
      };

    case REWARD_REDEEM_REJECTED:
      return {
        ...state,
        redemptionStatus: TransactionStatusEnum.failed,
      };

    default:
      return state;
  }
};

export default reducer;



// WEBPACK FOOTER //
// ./src/reducers/redeemReward.js